var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('layout-default-new',[(_vm.loading)?_c('div',[_vm._v("Loading.....")]):_vm._e(),_c('div',[_vm._v("Getting Order Report please wait....")])])}
var staticRenderFns = []

export { render, staticRenderFns }